import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs'
import { mergeMapTo } from 'rxjs/operators';
@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  private updateUserName = new BehaviorSubject<string>('default value');

  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messages
      .subscribe((message) => {  });
  }


  setValue(value: string) {
    this.updateUserName.next(value);
  }

  getValue() {
    return this.updateUserName.asObservable();
  }
  
  requestPermission() {
    this.angularFireMessaging.requestToken
    .subscribe(
      (token) => { console.log('Permission granted! Save to the server!', token); },
      (error) => { console.error(error); },  
    );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (msg) => {
        console.log("show message!", msg);
        this.currentMessage.next(msg);
      })
  }
}
